import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthRequestModel, UserModel } from '@tsin-core/models/auth.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const AUTH_VALIDATE_USER = `${environment.authBaseUrl}/auth/authenticate-profiile`;
const AUTH_LOGOUT = `${environment.authBaseUrl}/auth/authenticate-profiile`;

const AUTH_VALIDATE_ADMIN = `${environment.wwuBaseUrl}/auth/authenticate-profiile`;
const AUTH_LOGOUT_ADMIN = `${environment.wwuBaseUrl}/auth/authenticate-profiile`;

const AUTH_VALIDATE_TOKEN = `${environment.apiUrl}/user/me`;

const AUTH_VALIDATE_TOKEN_WWU = `${environment.wwuBaseUrl}/user/me`;

@Injectable({
  providedIn: 'root'
})

// The authentication service
export class AuthService {

  // Inject the http client into auth service
  http: HttpClient = inject(HttpClient);

  // Method for endpoint to validate the user and return a token
  validate(credentials: AuthRequestModel) {
    // console.log('CREDENTIALS', credentials)
    return this.http.post(AUTH_VALIDATE_USER, credentials)
  }

  // Method for endpoint to logout a user from the server
  logout() {
    return this.http.delete(AUTH_LOGOUT)
  }

  // Method for endpoint to validate the user and return a token
  validateAdmin(credentials: AuthRequestModel) {
    console.log('CREDENTIALS', credentials)
    return this.http.post(AUTH_VALIDATE_ADMIN, credentials)
  }

  validateToken(payload: { token: string; refreshToken: string }): Observable<UserModel> {
    return this.http.get<UserModel>(AUTH_VALIDATE_TOKEN, {
      headers: {
        "Authorization": `Bearer ${payload.token}`
      }
    })
  }

  validateTokenWWU(payload: { token: string; refreshToken: string }): Observable<UserModel> {
    return this.http.get<UserModel>(AUTH_VALIDATE_TOKEN_WWU, {
      headers: {
        "Authorization": `Bearer ${payload.token}`
      }
    })
  }

  refreshToken(payload: { refreshToken: string }): Observable<{ token: string; refreshToken: string }> {
    return this.http.post<{ token: string; refreshToken: string }>(`${environment.authBaseUrl}/auth/refresh`, payload);
  }

  // Method for endpoint to logout a user from the server
  logoutAdmin() {
    return this.http.delete(AUTH_LOGOUT_ADMIN)
  }
}
